// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file general.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LocationStatus, LocationStatusJson, UserRole, UserRoleJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file general.proto.
 */
export const file_general: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_google_protobuf_timestamp]);

/**
 * A slim User: user.proto imports organization.proto, so organization.proto and
 * pickup_location.proto cannot nest the full User message without a circular import.
 *
 * @generated from message raccoonai.UserRef
 */
export type UserRef = Message<"raccoonai.UserRef"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string first_name = 2 [json_name = "first_name"];
   */
  firstName: string;

  /**
   * @generated from field: optional string last_name = 3 [json_name = "last_name"];
   */
  lastName: string;

  /**
   * @generated from field: optional string phone_number = 4 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email: string;

  /**
   * @generated from field: optional raccoonai.UserRole role = 6;
   */
  role: UserRole;
};

/**
 * A slim User: user.proto imports organization.proto, so organization.proto and
 * pickup_location.proto cannot nest the full User message without a circular import.
 *
 * @generated from message raccoonai.UserRef
 */
export type UserRefJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string first_name = 2 [json_name = "first_name"];
   */
  first_name?: string;

  /**
   * @generated from field: optional string last_name = 3 [json_name = "last_name"];
   */
  last_name?: string;

  /**
   * @generated from field: optional string phone_number = 4 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 5;
   */
  email?: string;

  /**
   * @generated from field: optional raccoonai.UserRole role = 6;
   */
  role?: UserRoleJson;
};

/**
 * Describes the message raccoonai.UserRef.
 * Use `create(UserRefSchema)` to create a new message.
 */
export const UserRefSchema: GenMessage<UserRef, {jsonType: UserRefJson}> = /*@__PURE__*/
  messageDesc(file_general, 0);

/**
 * @generated from message raccoonai.DateTimeFilter
 */
export type DateTimeFilter = Message<"raccoonai.DateTimeFilter"> & {
  /**
   * @generated from field: required google.protobuf.Timestamp from = 1;
   */
  from?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp to = 2;
   */
  to?: Timestamp;

  /**
   * Which time column the range applies to, snake_case, e.g. "fact_start_at".
   * Must be a time field of the listed entity; unknown names are rejected.
   * Omitted = the endpoint's default time column.
   * Deprecated: use fields. Not allowed together with fields.
   *
   * @generated from field: optional string field = 3;
   */
  field: string;

  /**
   * Like field, but the first non-null column wins, e.g. ["started_at", "tw_start_at"].
   *
   * @generated from field: repeated string fields = 4;
   */
  fields: string[];
};

/**
 * @generated from message raccoonai.DateTimeFilter
 */
export type DateTimeFilterJson = {
  /**
   * @generated from field: required google.protobuf.Timestamp from = 1;
   */
  from?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp to = 2;
   */
  to?: TimestampJson;

  /**
   * Which time column the range applies to, snake_case, e.g. "fact_start_at".
   * Must be a time field of the listed entity; unknown names are rejected.
   * Omitted = the endpoint's default time column.
   * Deprecated: use fields. Not allowed together with fields.
   *
   * @generated from field: optional string field = 3;
   */
  field?: string;

  /**
   * Like field, but the first non-null column wins, e.g. ["started_at", "tw_start_at"].
   *
   * @generated from field: repeated string fields = 4;
   */
  fields?: string[];
};

/**
 * Describes the message raccoonai.DateTimeFilter.
 * Use `create(DateTimeFilterSchema)` to create a new message.
 */
export const DateTimeFilterSchema: GenMessage<DateTimeFilter, {jsonType: DateTimeFilterJson}> = /*@__PURE__*/
  messageDesc(file_general, 1);

/**
 * @generated from message raccoonai.DateFilter
 */
export type DateFilter = Message<"raccoonai.DateFilter"> & {
  /**
   * Inclusive start date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   *
   * @generated from field: required string from = 1;
   */
  from: string;

  /**
   * Inclusive end date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   *
   * @generated from field: required string to = 2;
   */
  to: string;
};

/**
 * @generated from message raccoonai.DateFilter
 */
export type DateFilterJson = {
  /**
   * Inclusive start date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   *
   * @generated from field: required string from = 1;
   */
  from?: string;

  /**
   * Inclusive end date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   *
   * @generated from field: required string to = 2;
   */
  to?: string;
};

/**
 * Describes the message raccoonai.DateFilter.
 * Use `create(DateFilterSchema)` to create a new message.
 */
export const DateFilterSchema: GenMessage<DateFilter, {jsonType: DateFilterJson}> = /*@__PURE__*/
  messageDesc(file_general, 2);

/**
 * @generated from message raccoonai.ErrorMessage
 */
export type ErrorMessage = Message<"raccoonai.ErrorMessage"> & {
  /**
   * To show clients what exactly went wrong, useful for client-side handling
   *
   * @generated from field: optional raccoonai.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * For developers
   *
   * @generated from field: repeated string messages = 2;
   */
  messages: string[];

  /**
   * Values for the message template a client renders for `code`, e.g.
   * {"id": "15574", "status": "DRIVER_ON_SHIFT_STATUS_IDLE"}. Enum values are
   * sent as their full proto name so the client can localize them too; ids are
   * decimal, timestamps RFC 3339.
   *
   * @generated from field: map<string, string> args = 3;
   */
  args: { [key: string]: string };
};

/**
 * @generated from message raccoonai.ErrorMessage
 */
export type ErrorMessageJson = {
  /**
   * To show clients what exactly went wrong, useful for client-side handling
   *
   * @generated from field: optional raccoonai.ErrorCode code = 1;
   */
  code?: ErrorCodeJson;

  /**
   * For developers
   *
   * @generated from field: repeated string messages = 2;
   */
  messages?: string[];

  /**
   * Values for the message template a client renders for `code`, e.g.
   * {"id": "15574", "status": "DRIVER_ON_SHIFT_STATUS_IDLE"}. Enum values are
   * sent as their full proto name so the client can localize them too; ids are
   * decimal, timestamps RFC 3339.
   *
   * @generated from field: map<string, string> args = 3;
   */
  args?: { [key: string]: string };
};

/**
 * Describes the message raccoonai.ErrorMessage.
 * Use `create(ErrorMessageSchema)` to create a new message.
 */
export const ErrorMessageSchema: GenMessage<ErrorMessage, {jsonType: ErrorMessageJson}> = /*@__PURE__*/
  messageDesc(file_general, 3);

/**
 * @generated from message raccoonai.MessageResponse
 */
export type MessageResponse = Message<"raccoonai.MessageResponse"> & {
  /**
   * @generated from field: required raccoonai.ResponseStatus status = 1;
   */
  status: ResponseStatus;

  /**
   * @generated from field: optional string message = 2;
   */
  message: string;

  /**
   * @generated from field: optional raccoonai.ErrorMessage error = 3;
   */
  error?: ErrorMessage;
};

/**
 * @generated from message raccoonai.MessageResponse
 */
export type MessageResponseJson = {
  /**
   * @generated from field: required raccoonai.ResponseStatus status = 1;
   */
  status?: ResponseStatusJson;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional raccoonai.ErrorMessage error = 3;
   */
  error?: ErrorMessageJson;
};

/**
 * Describes the message raccoonai.MessageResponse.
 * Use `create(MessageResponseSchema)` to create a new message.
 */
export const MessageResponseSchema: GenMessage<MessageResponse, {jsonType: MessageResponseJson}> = /*@__PURE__*/
  messageDesc(file_general, 4);

/**
 * @generated from message raccoonai.EmptyMessageRequest
 */
export type EmptyMessageRequest = Message<"raccoonai.EmptyMessageRequest"> & {
};

/**
 * @generated from message raccoonai.EmptyMessageRequest
 */
export type EmptyMessageRequestJson = {
};

/**
 * Describes the message raccoonai.EmptyMessageRequest.
 * Use `create(EmptyMessageRequestSchema)` to create a new message.
 */
export const EmptyMessageRequestSchema: GenMessage<EmptyMessageRequest, {jsonType: EmptyMessageRequestJson}> = /*@__PURE__*/
  messageDesc(file_general, 5);

/**
 * @generated from message raccoonai.EmptyMessageResponse
 */
export type EmptyMessageResponse = Message<"raccoonai.EmptyMessageResponse"> & {
};

/**
 * @generated from message raccoonai.EmptyMessageResponse
 */
export type EmptyMessageResponseJson = {
};

/**
 * Describes the message raccoonai.EmptyMessageResponse.
 * Use `create(EmptyMessageResponseSchema)` to create a new message.
 */
export const EmptyMessageResponseSchema: GenMessage<EmptyMessageResponse, {jsonType: EmptyMessageResponseJson}> = /*@__PURE__*/
  messageDesc(file_general, 6);

/**
 * A clearable id list in an update: absent keeps the stored list, present and empty clears it.
 *
 * @generated from message raccoonai.IdList
 */
export type IdList = Message<"raccoonai.IdList"> & {
  /**
   * @generated from field: repeated uint64 ids = 1;
   */
  ids: bigint[];
};

/**
 * A clearable id list in an update: absent keeps the stored list, present and empty clears it.
 *
 * @generated from message raccoonai.IdList
 */
export type IdListJson = {
  /**
   * @generated from field: repeated uint64 ids = 1;
   */
  ids?: string[];
};

/**
 * Describes the message raccoonai.IdList.
 * Use `create(IdListSchema)` to create a new message.
 */
export const IdListSchema: GenMessage<IdList, {jsonType: IdListJson}> = /*@__PURE__*/
  messageDesc(file_general, 7);

/**
 * @generated from message raccoonai.IdRequest
 */
export type IdRequest = Message<"raccoonai.IdRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;
};

/**
 * @generated from message raccoonai.IdRequest
 */
export type IdRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;
};

/**
 * Describes the message raccoonai.IdRequest.
 * Use `create(IdRequestSchema)` to create a new message.
 */
export const IdRequestSchema: GenMessage<IdRequest, {jsonType: IdRequestJson}> = /*@__PURE__*/
  messageDesc(file_general, 8);

/**
 * @generated from message raccoonai.ListFilter
 */
export type ListFilter = Message<"raccoonai.ListFilter"> & {
  /**
   * starting from 0 (OFFSET)
   *
   * @generated from field: optional uint32 current_page = 1 [default = 0, json_name = "current_page"];
   */
  currentPage: number;

  /**
   * max 100 (LIMIT)
   *
   * @generated from field: optional uint32 page_size = 2 [default = 50, json_name = "page_size"];
   */
  pageSize: number;

  /**
   * field name to sort by, default is "id"
   *
   * @generated from field: optional string sort_by = 3 [default = "id", json_name = "sort_by"];
   */
  sortBy: string;

  /**
   * @generated from field: optional raccoonai.SortDirection sort_direction = 4 [default = SORT_DIRECTION_DESCENDING, json_name = "sort_direction"];
   */
  sortDirection: SortDirection;

  /**
   * Facets to count over the whole match, each returned in ListInfo.facets under its
   * name. Each list request documents the names it supports on its list_filter; any
   * other name is rejected with InvalidArgument.
   *
   * @generated from field: repeated string facets = 5;
   */
  facets: string[];
};

/**
 * @generated from message raccoonai.ListFilter
 */
export type ListFilterJson = {
  /**
   * starting from 0 (OFFSET)
   *
   * @generated from field: optional uint32 current_page = 1 [default = 0, json_name = "current_page"];
   */
  current_page?: number;

  /**
   * max 100 (LIMIT)
   *
   * @generated from field: optional uint32 page_size = 2 [default = 50, json_name = "page_size"];
   */
  page_size?: number;

  /**
   * field name to sort by, default is "id"
   *
   * @generated from field: optional string sort_by = 3 [default = "id", json_name = "sort_by"];
   */
  sort_by?: string;

  /**
   * @generated from field: optional raccoonai.SortDirection sort_direction = 4 [default = SORT_DIRECTION_DESCENDING, json_name = "sort_direction"];
   */
  sort_direction?: SortDirectionJson;

  /**
   * Facets to count over the whole match, each returned in ListInfo.facets under its
   * name. Each list request documents the names it supports on its list_filter; any
   * other name is rejected with InvalidArgument.
   *
   * @generated from field: repeated string facets = 5;
   */
  facets?: string[];
};

/**
 * Describes the message raccoonai.ListFilter.
 * Use `create(ListFilterSchema)` to create a new message.
 */
export const ListFilterSchema: GenMessage<ListFilter, {jsonType: ListFilterJson}> = /*@__PURE__*/
  messageDesc(file_general, 9);

/**
 * FacetCounts is one facet's row counts, keyed by enum value. A facet is counted under
 * every filter of the request but its own, so a tab keeps its count while selected.
 * Every value of the enum is present, 0 where nothing matched; a value the enum does
 * not know (legacy, empty, NULL) counts under its zero value, UNDEFINED, present only
 * when nonzero. Clients never show UNDEFINED on its own.
 *
 * @generated from message raccoonai.FacetCounts
 */
export type FacetCounts = Message<"raccoonai.FacetCounts"> & {
  /**
   * @generated from field: map<int32, uint32> counts = 1;
   */
  counts: { [key: number]: number };

  /**
   * Id facets (a reference column) count here instead, keyed by the referenced id;
   * key 0 counts the rows with no value, as id 0 filters them. An id missing from the
   * map counts 0.
   *
   * @generated from field: map<uint64, uint32> id_counts = 2 [json_name = "id_counts"];
   */
  idCounts: { [key: string]: number };
};

/**
 * FacetCounts is one facet's row counts, keyed by enum value. A facet is counted under
 * every filter of the request but its own, so a tab keeps its count while selected.
 * Every value of the enum is present, 0 where nothing matched; a value the enum does
 * not know (legacy, empty, NULL) counts under its zero value, UNDEFINED, present only
 * when nonzero. Clients never show UNDEFINED on its own.
 *
 * @generated from message raccoonai.FacetCounts
 */
export type FacetCountsJson = {
  /**
   * @generated from field: map<int32, uint32> counts = 1;
   */
  counts?: { [key: number]: number };

  /**
   * Id facets (a reference column) count here instead, keyed by the referenced id;
   * key 0 counts the rows with no value, as id 0 filters them. An id missing from the
   * map counts 0.
   *
   * @generated from field: map<uint64, uint32> id_counts = 2 [json_name = "id_counts"];
   */
  id_counts?: { [key: string]: number };
};

/**
 * Describes the message raccoonai.FacetCounts.
 * Use `create(FacetCountsSchema)` to create a new message.
 */
export const FacetCountsSchema: GenMessage<FacetCounts, {jsonType: FacetCountsJson}> = /*@__PURE__*/
  messageDesc(file_general, 10);

/**
 * @generated from message raccoonai.ListInfo
 */
export type ListInfo = Message<"raccoonai.ListInfo"> & {
  /**
   * @generated from field: required uint32 total_items = 1 [json_name = "total_items"];
   */
  totalItems: number;

  /**
   * <-- ListFilter.current_page
   *
   * @generated from field: required uint32 current_page = 2 [json_name = "current_page"];
   */
  currentPage: number;

  /**
   * <-- ListFilter.page_size
   *
   * @generated from field: required uint32 page_size = 3 [json_name = "page_size"];
   */
  pageSize: number;

  /**
   * @generated from field: optional string sort_by = 4 [default = "id", json_name = "sort_by"];
   */
  sortBy: string;

  /**
   * @generated from field: optional raccoonai.SortDirection sort_direction = 5 [default = SORT_DIRECTION_DESCENDING, json_name = "sort_direction"];
   */
  sortDirection: SortDirection;

  /**
   * The requested ListFilter.facets, by name.
   *
   * @generated from field: map<string, raccoonai.FacetCounts> facets = 6;
   */
  facets: { [key: string]: FacetCounts };
};

/**
 * @generated from message raccoonai.ListInfo
 */
export type ListInfoJson = {
  /**
   * @generated from field: required uint32 total_items = 1 [json_name = "total_items"];
   */
  total_items?: number;

  /**
   * <-- ListFilter.current_page
   *
   * @generated from field: required uint32 current_page = 2 [json_name = "current_page"];
   */
  current_page?: number;

  /**
   * <-- ListFilter.page_size
   *
   * @generated from field: required uint32 page_size = 3 [json_name = "page_size"];
   */
  page_size?: number;

  /**
   * @generated from field: optional string sort_by = 4 [default = "id", json_name = "sort_by"];
   */
  sort_by?: string;

  /**
   * @generated from field: optional raccoonai.SortDirection sort_direction = 5 [default = SORT_DIRECTION_DESCENDING, json_name = "sort_direction"];
   */
  sort_direction?: SortDirectionJson;

  /**
   * The requested ListFilter.facets, by name.
   *
   * @generated from field: map<string, raccoonai.FacetCounts> facets = 6;
   */
  facets?: { [key: string]: FacetCountsJson };
};

/**
 * Describes the message raccoonai.ListInfo.
 * Use `create(ListInfoSchema)` to create a new message.
 */
export const ListInfoSchema: GenMessage<ListInfo, {jsonType: ListInfoJson}> = /*@__PURE__*/
  messageDesc(file_general, 11);

/**
 * An organization's own label: pickup location types, customer types. A name for
 * filtering and display only, no business rule depends on it. Unlike TruckType or
 * ContainerType, it carries no attributes; add a new label kind, not fields here.
 *
 * @generated from message raccoonai.OrganizationLabel
 */
export type OrganizationLabel = Message<"raccoonai.OrganizationLabel"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * INACTIVE is the archive: kept where already assigned, not assignable.
   *
   * @generated from field: required raccoonai.LocationStatus status = 4;
   */
  status: LocationStatus;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * An organization's own label: pickup location types, customer types. A name for
 * filtering and display only, no business rule depends on it. Unlike TruckType or
 * ContainerType, it carries no attributes; add a new label kind, not fields here.
 *
 * @generated from message raccoonai.OrganizationLabel
 */
export type OrganizationLabelJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * INACTIVE is the archive: kept where already assigned, not assignable.
   *
   * @generated from field: required raccoonai.LocationStatus status = 4;
   */
  status?: LocationStatusJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.OrganizationLabel.
 * Use `create(OrganizationLabelSchema)` to create a new message.
 */
export const OrganizationLabelSchema: GenMessage<OrganizationLabel, {jsonType: OrganizationLabelJson}> = /*@__PURE__*/
  messageDesc(file_general, 12);

/**
 * @generated from message raccoonai.OrganizationLabelCreate
 */
export type OrganizationLabelCreate = Message<"raccoonai.OrganizationLabelCreate"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;
};

/**
 * @generated from message raccoonai.OrganizationLabelCreate
 */
export type OrganizationLabelCreateJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;
};

/**
 * Describes the message raccoonai.OrganizationLabelCreate.
 * Use `create(OrganizationLabelCreateSchema)` to create a new message.
 */
export const OrganizationLabelCreateSchema: GenMessage<OrganizationLabelCreate, {jsonType: OrganizationLabelCreateJson}> = /*@__PURE__*/
  messageDesc(file_general, 13);

/**
 * @generated from message raccoonai.OrganizationLabelUpdate
 */
export type OrganizationLabelUpdate = Message<"raccoonai.OrganizationLabelUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 4;
   */
  status: LocationStatus;
};

/**
 * @generated from message raccoonai.OrganizationLabelUpdate
 */
export type OrganizationLabelUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.LocationStatus status = 4;
   */
  status?: LocationStatusJson;
};

/**
 * Describes the message raccoonai.OrganizationLabelUpdate.
 * Use `create(OrganizationLabelUpdateSchema)` to create a new message.
 */
export const OrganizationLabelUpdateSchema: GenMessage<OrganizationLabelUpdate, {jsonType: OrganizationLabelUpdateJson}> = /*@__PURE__*/
  messageDesc(file_general, 14);

/**
 * @generated from message raccoonai.OrganizationLabelListRequest
 */
export type OrganizationLabelListRequest = Message<"raccoonai.OrganizationLabelListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 2;
   */
  statuses: LocationStatus[];

  /**
   * facets: "status" (LocationStatus).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.OrganizationLabelListRequest
 */
export type OrganizationLabelListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 2;
   */
  statuses?: LocationStatusJson[];

  /**
   * facets: "status" (LocationStatus).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.OrganizationLabelListRequest.
 * Use `create(OrganizationLabelListRequestSchema)` to create a new message.
 */
export const OrganizationLabelListRequestSchema: GenMessage<OrganizationLabelListRequest, {jsonType: OrganizationLabelListRequestJson}> = /*@__PURE__*/
  messageDesc(file_general, 15);

/**
 * @generated from message raccoonai.OrganizationLabelList
 */
export type OrganizationLabelList = Message<"raccoonai.OrganizationLabelList"> & {
  /**
   * @generated from field: repeated raccoonai.OrganizationLabel labels = 1;
   */
  labels: OrganizationLabel[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.OrganizationLabelList
 */
export type OrganizationLabelListJson = {
  /**
   * @generated from field: repeated raccoonai.OrganizationLabel labels = 1;
   */
  labels?: OrganizationLabelJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.OrganizationLabelList.
 * Use `create(OrganizationLabelListSchema)` to create a new message.
 */
export const OrganizationLabelListSchema: GenMessage<OrganizationLabelList, {jsonType: OrganizationLabelListJson}> = /*@__PURE__*/
  messageDesc(file_general, 16);

/**
 * @generated from enum raccoonai.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Authentication
   *
   * @generated from enum value: ERROR_CODE_AUTH_HEADER_ISSUE = 101;
   */
  AUTH_HEADER_ISSUE = 101,

  /**
   * @generated from enum value: ERROR_CODE_AUTH_TOKEN_ISSUE = 102;
   */
  AUTH_TOKEN_ISSUE = 102,

  /**
   * @generated from enum value: ERROR_CODE_AUTH_TOKEN_INVALID = 103;
   */
  AUTH_TOKEN_INVALID = 103,

  /**
   * @generated from enum value: ERROR_CODE_AUTH_MISSING_CTX = 104;
   */
  AUTH_MISSING_CTX = 104,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_CREDENTIALS = 105;
   */
  INVALID_CREDENTIALS = 105,

  /**
   * Access token (or other credential, e.g. registration token) has expired.
   * For an expired access token the client should call RefreshToken.
   *
   * @generated from enum value: ERROR_CODE_AUTH_EXPIRED = 106;
   */
  AUTH_EXPIRED = 106,

  /**
   * @generated from enum value: ERROR_CODE_AUTH_INVALID_USER_DATA = 107;
   */
  AUTH_INVALID_USER_DATA = 107,

  /**
   * @generated from enum value: ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED = 108;
   */
  NO_PHONE_OR_EMAIL_PROVIDED = 108,

  /**
   * @generated from enum value: ERROR_CODE_OTP_SERVICE_ISSUE = 109;
   */
  OTP_SERVICE_ISSUE = 109,

  /**
   * @generated from enum value: ERROR_CODE_OTP_INVALID = 110;
   */
  OTP_INVALID = 110,

  /**
   * @generated from enum value: ERROR_CODE_OTP_EXPIRED = 111;
   */
  OTP_EXPIRED = 111,

  /**
   * @generated from enum value: ERROR_CODE_OTP_RATE_LIMIT = 112;
   */
  OTP_RATE_LIMIT = 112,

  /**
   * @generated from enum value: ERROR_CODE_PASSWORD_RESET_ISSUE = 113;
   */
  PASSWORD_RESET_ISSUE = 113,

  /**
   * @generated from enum value: ERROR_CODE_OTP_EMAIL_REQUIRED = 114;
   */
  OTP_EMAIL_REQUIRED = 114,

  /**
   * @generated from enum value: ERROR_CODE_OTP_PHONE_REQUIRED = 115;
   */
  OTP_PHONE_REQUIRED = 115,

  /**
   * @generated from enum value: ERROR_CODE_USER_INACTIVE = 116;
   */
  USER_INACTIVE = 116,

  /**
   * Refresh token is malformed, has a bad signature, or is not a refresh
   * token. Client must re-login.
   *
   * @generated from enum value: ERROR_CODE_REFRESH_TOKEN_INVALID = 117;
   */
  REFRESH_TOKEN_INVALID = 117,

  /**
   * Refresh token has expired. Client must re-login.
   *
   * @generated from enum value: ERROR_CODE_REFRESH_TOKEN_EXPIRED = 118;
   */
  REFRESH_TOKEN_EXPIRED = 118,

  /**
   * The session behind the token no longer exists: logged out, revoked, or
   * killed after refresh-token reuse was detected. Client must re-login.
   *
   * @generated from enum value: ERROR_CODE_SESSION_REVOKED = 119;
   */
  SESSION_REVOKED = 119,

  /**
   * Permission/Authorization errors
   *
   * @generated from enum value: ERROR_CODE_PERMISSION_DENIED = 201;
   */
  PERMISSION_DENIED = 201,

  /**
   * @generated from enum value: ERROR_CODE_NO_ACCESS = 202;
   */
  NO_ACCESS = 202,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_PERMISSION_REQUEST = 203;
   */
  INVALID_PERMISSION_REQUEST = 203,

  /**
   * @generated from enum value: ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED = 204;
   */
  OWNER_ORGANIZATION_LIST_REQUIRED = 204,

  /**
   * @generated from enum value: ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED = 205;
   */
  SERVICE_PROVIDER_LIST_REQUIRED = 205,

  /**
   * @generated from enum value: ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED = 206;
   */
  SERVICE_RECEIVER_LIST_REQUIRED = 206,

  /**
   * @generated from enum value: ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED = 207;
   */
  TARGET_ORGANIZATION_LIST_REQUIRED = 207,

  /**
   * @generated from enum value: ERROR_CODE_GRANT_OPERATION_FAILED = 211;
   */
  GRANT_OPERATION_FAILED = 211,

  /**
   * @generated from enum value: ERROR_CODE_MEMBERSHIP_OPERATION_FAILED = 212;
   */
  MEMBERSHIP_OPERATION_FAILED = 212,

  /**
   * @generated from enum value: ERROR_CODE_ADMIN_ACTION_REQUIRED = 213;
   */
  ADMIN_ACTION_REQUIRED = 213,

  /**
   * @generated from enum value: ERROR_CODE_UNDEFINED_ROLE = 220;
   */
  UNDEFINED_ROLE = 220,

  /**
   * @generated from enum value: ERROR_CODE_ROLE_NOT_ALLOWED = 221;
   */
  ROLE_NOT_ALLOWED = 221,

  /**
   * Validation errors
   *
   * @generated from enum value: ERROR_CODE_REQUIRED_FIELD_MISSING = 301;
   */
  REQUIRED_FIELD_MISSING = 301,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_FIELD_VALUE = 302;
   */
  INVALID_FIELD_VALUE = 302,

  /**
   * @generated from enum value: ERROR_CODE_DUPLICATE_ENTRY = 303;
   */
  DUPLICATE_ENTRY = 303,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_FORMAT = 304;
   */
  INVALID_FORMAT = 304,

  /**
   * @generated from enum value: ERROR_CODE_VALUE_TOO_SHORT = 305;
   */
  VALUE_TOO_SHORT = 305,

  /**
   * @generated from enum value: ERROR_CODE_VALUE_TOO_LONG = 306;
   */
  VALUE_TOO_LONG = 306,

  /**
   * @generated from enum value: ERROR_CODE_OUT_OF_RANGE = 307;
   */
  OUT_OF_RANGE = 307,

  /**
   * @generated from enum value: ERROR_CODE_FILE_REQUIRED = 308;
   */
  FILE_REQUIRED = 308,

  /**
   * @generated from enum value: ERROR_CODE_FILTER_REQUIRED = 309;
   */
  FILTER_REQUIRED = 309,

  /**
   * @generated from enum value: ERROR_CODE_FILTER_INVALID = 310;
   */
  FILTER_INVALID = 310,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_ENUM_VALUE = 311;
   */
  INVALID_ENUM_VALUE = 311,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_REQUEST_STATE = 312;
   */
  INVALID_REQUEST_STATE = 312,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_TYPE_MISMATCH = 313;
   */
  ORGANIZATION_TYPE_MISMATCH = 313,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_VALUE = 314;
   */
  INVALID_VALUE = 314,

  /**
   * Validation errors related to contracts
   *
   * @generated from enum value: ERROR_CODE_CONTRACT_NOT_FOUND = 330;
   */
  CONTRACT_NOT_FOUND = 330,

  /**
   * @generated from enum value: ERROR_CODE_CONTRACT_EXPIRED = 331;
   */
  CONTRACT_EXPIRED = 331,

  /**
   * @generated from enum value: ERROR_CODE_CONTRACT_NOT_ACTIVE = 332;
   */
  CONTRACT_NOT_ACTIVE = 332,

  /**
   * @generated from enum value: ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND = 333;
   */
  CONTRACT_JOB_TARIFF_NOT_FOUND = 333,

  /**
   * File / storage errors
   *
   * @generated from enum value: ERROR_CODE_FILE_INVALID_BASE64 = 320;
   */
  FILE_INVALID_BASE64 = 320,

  /**
   * @generated from enum value: ERROR_CODE_FILE_UPLOAD_FAILED = 321;
   */
  FILE_UPLOAD_FAILED = 321,

  /**
   * @generated from enum value: ERROR_CODE_FILE_TYPE_INVALID = 322;
   */
  FILE_TYPE_INVALID = 322,

  /**
   * Look-up errors
   *
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 401;
   */
  NOT_FOUND = 401,

  /**
   * @generated from enum value: ERROR_CODE_MULTIPLE_FOUND = 402;
   */
  MULTIPLE_FOUND = 402,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_ID = 403;
   */
  INVALID_ID = 403,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_QUERY = 404;
   */
  INVALID_QUERY = 404,

  /**
   * @generated from enum value: ERROR_CODE_RELATED_ENTITY_NOT_FOUND = 405;
   */
  RELATED_ENTITY_NOT_FOUND = 405,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NOT_FOUND = 406;
   */
  ORGANIZATION_NOT_FOUND = 406,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_TYPE_NOT_FOUND = 407;
   */
  CONTAINER_TYPE_NOT_FOUND = 407,

  /**
   * @generated from enum value: ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER = 408;
   */
  NO_ACTIVE_ROUTE_FOR_DRIVER = 408,

  /**
   * @generated from enum value: ERROR_CODE_LOOKUP_FAILED = 409;
   */
  LOOKUP_FAILED = 409,

  /**
   * @generated from enum value: ERROR_CODE_SHIFT_ALREADY_EXISTS = 410;
   */
  SHIFT_ALREADY_EXISTS = 410,

  /**
   * Creation errors
   *
   * @generated from enum value: ERROR_CODE_CREATION_NOT_ALLOWED = 501;
   */
  CREATION_NOT_ALLOWED = 501,

  /**
   * @generated from enum value: ERROR_CODE_CREATE_ISSUE = 502;
   */
  CREATE_ISSUE = 502,

  /**
   * @generated from enum value: ERROR_CODE_DUPLICATE_PHONE_NUMBER = 503;
   */
  DUPLICATE_PHONE_NUMBER = 503,

  /**
   * @generated from enum value: ERROR_CODE_DUPLICATE_EMAIL = 504;
   */
  DUPLICATE_EMAIL = 504,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_EXISTS = 505;
   */
  ALREADY_EXISTS = 505,

  /**
   * @generated from enum value: ERROR_CODE_CREATION_FAILED = 506;
   */
  CREATION_FAILED = 506,

  /**
   * Update errors
   *
   * @generated from enum value: ERROR_CODE_UPDATE_NOT_ALLOWED = 601;
   */
  UPDATE_NOT_ALLOWED = 601,

  /**
   * @generated from enum value: ERROR_CODE_UPDATE_FAILED = 602;
   */
  UPDATE_FAILED = 602,

  /**
   * @generated from enum value: ERROR_CODE_UPDATE_INVALID = 603;
   */
  UPDATE_INVALID = 603,

  /**
   * Deletion errors
   *
   * @generated from enum value: ERROR_CODE_DELETION_NOT_ALLOWED = 701;
   */
  DELETION_NOT_ALLOWED = 701,

  /**
   * @generated from enum value: ERROR_CODE_DELETION_FAILED = 702;
   */
  DELETION_FAILED = 702,

  /**
   * @generated from enum value: ERROR_CODE_DELETION_INVALID = 703;
   */
  DELETION_INVALID = 703,

  /**
   * Internal server errors
   *
   * @generated from enum value: ERROR_CODE_GORM_TO_PROTO_CONVERSION = 801;
   */
  GORM_TO_PROTO_CONVERSION = 801,

  /**
   * @generated from enum value: ERROR_CODE_PROTO_TO_GORM_CONVERSION = 802;
   */
  PROTO_TO_GORM_CONVERSION = 802,

  /**
   * @generated from enum value: ERROR_CODE_DATA_MARSHALING_FAILED = 803;
   */
  DATA_MARSHALING_FAILED = 803,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL = 804;
   */
  INTERNAL = 804,

  /**
   * External service errors
   *
   * @generated from enum value: ERROR_CODE_PERMIFY_ISSUE = 901;
   */
  PERMIFY_ISSUE = 901,

  /**
   * Unexpected error from file storage service (e.g., S3)
   *
   * @generated from enum value: ERROR_CODE_STORAGE_SERVICE_ISSUE = 902;
   */
  STORAGE_SERVICE_ISSUE = 902,

  /**
   * @generated from enum value: ERROR_CODE_WHATSAPP_SENDING_ISSUE = 903;
   */
  WHATSAPP_SENDING_ISSUE = 903,

  /**
   * @generated from enum value: ERROR_CODE_EMAIL_SENDING_ISSUE = 904;
   */
  EMAIL_SENDING_ISSUE = 904,

  /**
   * @generated from enum value: ERROR_CODE_DATABASE_ISSUE = 905;
   */
  DATABASE_ISSUE = 905,

  /**
   * @generated from enum value: ERROR_CODE_NOSQL_DATABASE_ISSUE = 906;
   */
  NOSQL_DATABASE_ISSUE = 906,

  /**
   * @generated from enum value: ERROR_CODE_VRP_SERVICE_ISSUE = 907;
   */
  VRP_SERVICE_ISSUE = 907,

  /**
   * @generated from enum value: ERROR_CODE_COST_PROVIDER_ISSUE = 908;
   */
  COST_PROVIDER_ISSUE = 908,

  /**
   * @generated from enum value: ERROR_CODE_VOXIMPLANT_ISSUE = 909;
   */
  VOXIMPLANT_ISSUE = 909,

  /**
   * @generated from enum value: ERROR_CODE_ENCRYPTION_FAILED = 910;
   */
  ENCRYPTION_FAILED = 910,

  /**
   * @generated from enum value: ERROR_CODE_DECRYPTION_FAILED = 911;
   */
  DECRYPTION_FAILED = 911,

  /**
   * route
   *
   * @generated from enum value: ERROR_CODE_ROUTE_FINAL = 1001;
   */
  ROUTE_FINAL = 1001,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NOT_RETURNING = 1002;
   */
  ROUTE_NOT_RETURNING = 1002,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_INVALID_TRANSITION = 1003;
   */
  ROUTE_INVALID_TRANSITION = 1003,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT = 1004;
   */
  ROUTE_NO_DRIVER_ON_SHIFT = 1004,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NOT_APPROVABLE = 1005;
   */
  ROUTE_NOT_APPROVABLE = 1005,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NOT_APPROVED = 1006;
   */
  ROUTE_NOT_APPROVED = 1006,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED = 1007;
   */
  ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED = 1007,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NO_DESTINATION = 1008;
   */
  ROUTE_NO_DESTINATION = 1008,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NOT_DISSOLVABLE = 1009;
   */
  ROUTE_NOT_DISSOLVABLE = 1009,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION = 1010;
   */
  ROUTE_SAME_SOURCE_DESTINATION = 1010,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS = 1011;
   */
  ROUTE_ANOTHER_IN_PROGRESS = 1011,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE = 1012;
   */
  ROUTE_NO_JOB_ON_SERVICE = 1012,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_DURATION_TOO_SHORT = 1013;
   */
  ROUTE_DURATION_TOO_SHORT = 1013,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_STOP_AMBIGUOUS = 1014;
   */
  ROUTE_STOP_AMBIGUOUS = 1014,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB = 1015;
   */
  ROUTE_STOP_DUPLICATE_JOB = 1015,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_RETURNING = 1016;
   */
  ROUTE_RETURNING = 1016,

  /**
   * @generated from enum value: ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE = 1017;
   */
  ROUTE_OWNER_NOT_IN_ZONE = 1017,

  /**
   * job
   *
   * @generated from enum value: ERROR_CODE_JOB_NOT_IN_ROUTE = 1101;
   */
  JOB_NOT_IN_ROUTE = 1101,

  /**
   * @generated from enum value: ERROR_CODE_JOB_ALREADY_ON_SERVICE = 1102;
   */
  JOB_ALREADY_ON_SERVICE = 1102,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NOT_ON_SERVICE = 1103;
   */
  JOB_NOT_ON_SERVICE = 1103,

  /**
   * @generated from enum value: ERROR_CODE_JOB_FINAL = 1104;
   */
  JOB_FINAL = 1104,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NOT_DETACHABLE = 1105;
   */
  JOB_NOT_DETACHABLE = 1105,

  /**
   * @generated from enum value: ERROR_CODE_JOB_INVALID_TRANSITION = 1106;
   */
  JOB_INVALID_TRANSITION = 1106,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NOT_ENROUTE = 1107;
   */
  JOB_NOT_ENROUTE = 1107,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT = 1108;
   */
  JOB_NO_DRIVER_ON_SHIFT = 1108,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NOT_COMPLETED = 1109;
   */
  JOB_NOT_COMPLETED = 1109,

  /**
   * @generated from enum value: ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE = 1110;
   */
  JOB_INSTRUCTIONS_NOT_EDITABLE = 1110,

  /**
   * @generated from enum value: ERROR_CODE_JOB_LIST_CONFLICT = 1111;
   */
  JOB_LIST_CONFLICT = 1111,

  /**
   * @generated from enum value: ERROR_CODE_JOB_NOT_LISTED = 1112;
   */
  JOB_NOT_LISTED = 1112,

  /**
   * @generated from enum value: ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY = 1113;
   */
  JOB_CATEGORY_NO_ROUTE_CATEGORY = 1113,

  /**
   * @generated from enum value: ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH = 1114;
   */
  JOB_ROUTE_CATEGORY_MISMATCH = 1114,

  /**
   * @generated from enum value: ERROR_CODE_JOB_HAS_NO_ROUTE = 1115;
   */
  JOB_HAS_NO_ROUTE = 1115,

  /**
   * @generated from enum value: ERROR_CODE_JOB_ALREADY_ASSIGNED = 1116;
   */
  JOB_ALREADY_ASSIGNED = 1116,

  /**
   * @generated from enum value: ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE = 1117;
   */
  JOB_SERVICE_PROVIDER_NOT_IN_ZONE = 1117,

  /**
   * @generated from enum value: ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE = 1118;
   */
  JOB_SERVICE_PROVIDER_NOT_CHANGEABLE = 1118,

  /**
   * driver_on_shift
   *
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE = 1201;
   */
  DRIVER_ON_SHIFT_NOT_APPROVABLE = 1201,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER = 1202;
   */
  DRIVER_ON_SHIFT_NO_DRIVER = 1202,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY = 1203;
   */
  DRIVER_ON_SHIFT_TRUCK_BUSY = 1203,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY = 1204;
   */
  DRIVER_ON_SHIFT_DRIVER_BUSY = 1204,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT = 1205;
   */
  DRIVER_ON_SHIFT_DRIVER_CONFLICT = 1205,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION = 1206;
   */
  DRIVER_ON_SHIFT_INVALID_TRANSITION = 1206,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED = 1207;
   */
  DRIVER_ON_SHIFT_ROUTE_UNFINISHED = 1207,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE = 1208;
   */
  DRIVER_ON_SHIFT_NOT_ASSIGNABLE = 1208,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK = 1209;
   */
  DRIVER_ON_SHIFT_NO_TRUCK = 1209,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE = 1210;
   */
  DRIVER_ON_SHIFT_START_NOT_FUTURE = 1210,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT = 1211;
   */
  DRIVER_ON_SHIFT_TOO_SHORT = 1211,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE = 1212;
   */
  DRIVER_ON_SHIFT_NOT_ACTIVATABLE = 1212,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED = 1213;
   */
  DRIVER_ON_SHIFT_WINDOW_ENDED = 1213,

  /**
   * truck
   *
   * @generated from enum value: ERROR_CODE_TRUCK_JOB_LIMIT = 1301;
   */
  TRUCK_JOB_LIMIT = 1301,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_JOB_INCOMPATIBLE = 1302;
   */
  TRUCK_JOB_INCOMPATIBLE = 1302,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_NO_DEPOT = 1303;
   */
  TRUCK_NO_DEPOT = 1303,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_NO_TYPE = 1304;
   */
  TRUCK_NO_TYPE = 1304,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET = 1305;
   */
  TRUCK_ENGINE_TYPE_ALREADY_SET = 1305,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET = 1306;
   */
  TRUCK_ENGINE_TYPE_NOT_SET = 1306,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_NOT_ACTIVE = 1307;
   */
  TRUCK_NOT_ACTIVE = 1307,

  /**
   * contract / container_group
   *
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_NOT_BOUND = 1401;
   */
  CONTAINER_GROUP_NOT_BOUND = 1401,

  /**
   * @generated from enum value: ERROR_CODE_CONTRACT_PARTIES_MISMATCH = 1402;
   */
  CONTRACT_PARTIES_MISMATCH = 1402,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE = 1403;
   */
  CONTAINER_GROUP_NO_SCHEDULE = 1403,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY = 1404;
   */
  CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY = 1404,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE = 1405;
   */
  CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE = 1405,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING = 1406;
   */
  CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING = 1406,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP = 1407;
   */
  CONTAINER_GROUP_SCHEDULE_OVERLAP = 1407,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES = 1408;
   */
  CONTAINER_GROUP_SCHEDULE_INVALID_RULES = 1408,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD = 1409;
   */
  CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD = 1409,

  /**
   * @generated from enum value: ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE = 1410;
   */
  CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE = 1410,

  /**
   * pickup_location / pickup_location_group
   *
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE = 1501;
   */
  PICKUP_LOCATION_NOT_IN_ROUTE = 1501,

  /**
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT = 1502;
   */
  PICKUP_LOCATION_NO_JOB_LEFT = 1502,

  /**
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED = 1503;
   */
  PICKUP_LOCATION_ALREADY_SERVED = 1503,

  /**
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_TOO_FAR = 1504;
   */
  PICKUP_LOCATION_TOO_FAR = 1504,

  /**
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK = 1505;
   */
  PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK = 1505,

  /**
   * @generated from enum value: ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS = 1506;
   */
  PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS = 1506,

  /**
   * organization
   *
   * @generated from enum value: ERROR_CODE_ORGANIZATION_MISMATCH = 1601;
   */
  ORGANIZATION_MISMATCH = 1601,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER = 1602;
   */
  ORGANIZATION_NOT_SERVICE_PROVIDER = 1602,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER = 1603;
   */
  ORGANIZATION_NOT_SERVICE_RECEIVER = 1603,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS = 1604;
   */
  ORGANIZATION_NO_PRICING_SETTINGS = 1604,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE = 1605;
   */
  ORGANIZATION_NO_HOURLY_RATE = 1605,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER = 1606;
   */
  ORGANIZATION_NO_NIGHT_MULTIPLIER = 1606,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT = 1607;
   */
  ORGANIZATION_NO_ACTIVE_DEPOT = 1607,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS = 1608;
   */
  ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS = 1608,

  /**
   * @generated from enum value: ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH = 1609;
   */
  ORGANIZATION_OUTSIDE_BRANCH = 1609,

  /**
   * user / driver
   *
   * @generated from enum value: ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION = 1701;
   */
  DRIVER_NOT_IN_ORGANIZATION = 1701,

  /**
   * shift_plan
   *
   * @generated from enum value: ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE = 1801;
   */
  SHIFT_PLAN_DATE_NOT_FUTURE = 1801,

  /**
   * @generated from enum value: ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER = 1802;
   */
  SHIFT_PLAN_USER_NOT_DRIVER = 1802,

  /**
   * contact
   *
   * @generated from enum value: ERROR_CODE_CONTACT_NO_PHONE_NUMBER = 1901;
   */
  CONTACT_NO_PHONE_NUMBER = 1901,

  /**
   * driver_price_list
   *
   * @generated from enum value: ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED = 2001;
   */
  DRIVER_PRICE_LIST_MONTH_CLOSED = 2001,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY = 2002;
   */
  DRIVER_PRICE_LIST_APPEND_ONLY = 2002,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED = 2003;
   */
  DRIVER_PRICE_LIST_ALREADY_PRICED = 2003,

  /**
   * @generated from enum value: ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE = 2004;
   */
  DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE = 2004,

  /**
   * resource_access_grant
   *
   * @generated from enum value: ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE = 2101;
   */
  RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE = 2101,

  /**
   * whatsapp
   *
   * @generated from enum value: ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED = 2201;
   */
  WHATSAPP_REPLY_WINDOW_CLOSED = 2201,

  /**
   * custom_group
   *
   * @generated from enum value: ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN = 2301;
   */
  CUSTOM_GROUP_NAME_TAKEN = 2301,

  /**
   * holding shared types: container and truck types are owned by the company that made them, used across its holding
   *
   * @generated from enum value: ERROR_CODE_TYPE_OUTSIDE_HOLDING = 2401;
   */
  TYPE_OUTSIDE_HOLDING = 2401,

  /**
   * @generated from enum value: ERROR_CODE_TYPE_NOT_OWNED = 2402;
   */
  TYPE_NOT_OWNED = 2402,

  /**
   * @generated from enum value: ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING = 2403;
   */
  TYPE_DUPLICATE_IN_HOLDING = 2403,

  /**
   * @generated from enum value: ERROR_CODE_TRUCK_TYPE_IN_USE = 2404;
   */
  TRUCK_TYPE_IN_USE = 2404,

  /**
   * Client-side conditions. The backend never sends these; they live here so a
   * client has one registry of every error it can show. Expect them in the
   * go-backend reachability report as permanently unreachable.
   *
   * @generated from enum value: ERROR_CODE_COMPANY_NOT_SELECTED = 9001;
   */
  COMPANY_NOT_SELECTED = 9001,
}

/**
 * @generated from enum raccoonai.ErrorCode
 */
export type ErrorCodeJson = "ERROR_CODE_UNDEFINED" | "ERROR_CODE_AUTH_HEADER_ISSUE" | "ERROR_CODE_AUTH_TOKEN_ISSUE" | "ERROR_CODE_AUTH_TOKEN_INVALID" | "ERROR_CODE_AUTH_MISSING_CTX" | "ERROR_CODE_INVALID_CREDENTIALS" | "ERROR_CODE_AUTH_EXPIRED" | "ERROR_CODE_AUTH_INVALID_USER_DATA" | "ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED" | "ERROR_CODE_OTP_SERVICE_ISSUE" | "ERROR_CODE_OTP_INVALID" | "ERROR_CODE_OTP_EXPIRED" | "ERROR_CODE_OTP_RATE_LIMIT" | "ERROR_CODE_PASSWORD_RESET_ISSUE" | "ERROR_CODE_OTP_EMAIL_REQUIRED" | "ERROR_CODE_OTP_PHONE_REQUIRED" | "ERROR_CODE_USER_INACTIVE" | "ERROR_CODE_REFRESH_TOKEN_INVALID" | "ERROR_CODE_REFRESH_TOKEN_EXPIRED" | "ERROR_CODE_SESSION_REVOKED" | "ERROR_CODE_PERMISSION_DENIED" | "ERROR_CODE_NO_ACCESS" | "ERROR_CODE_INVALID_PERMISSION_REQUEST" | "ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED" | "ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED" | "ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED" | "ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED" | "ERROR_CODE_GRANT_OPERATION_FAILED" | "ERROR_CODE_MEMBERSHIP_OPERATION_FAILED" | "ERROR_CODE_ADMIN_ACTION_REQUIRED" | "ERROR_CODE_UNDEFINED_ROLE" | "ERROR_CODE_ROLE_NOT_ALLOWED" | "ERROR_CODE_REQUIRED_FIELD_MISSING" | "ERROR_CODE_INVALID_FIELD_VALUE" | "ERROR_CODE_DUPLICATE_ENTRY" | "ERROR_CODE_INVALID_FORMAT" | "ERROR_CODE_VALUE_TOO_SHORT" | "ERROR_CODE_VALUE_TOO_LONG" | "ERROR_CODE_OUT_OF_RANGE" | "ERROR_CODE_FILE_REQUIRED" | "ERROR_CODE_FILTER_REQUIRED" | "ERROR_CODE_FILTER_INVALID" | "ERROR_CODE_INVALID_ENUM_VALUE" | "ERROR_CODE_INVALID_REQUEST_STATE" | "ERROR_CODE_ORGANIZATION_TYPE_MISMATCH" | "ERROR_CODE_INVALID_VALUE" | "ERROR_CODE_CONTRACT_NOT_FOUND" | "ERROR_CODE_CONTRACT_EXPIRED" | "ERROR_CODE_CONTRACT_NOT_ACTIVE" | "ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND" | "ERROR_CODE_FILE_INVALID_BASE64" | "ERROR_CODE_FILE_UPLOAD_FAILED" | "ERROR_CODE_FILE_TYPE_INVALID" | "ERROR_CODE_NOT_FOUND" | "ERROR_CODE_MULTIPLE_FOUND" | "ERROR_CODE_INVALID_ID" | "ERROR_CODE_INVALID_QUERY" | "ERROR_CODE_RELATED_ENTITY_NOT_FOUND" | "ERROR_CODE_ORGANIZATION_NOT_FOUND" | "ERROR_CODE_CONTAINER_TYPE_NOT_FOUND" | "ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER" | "ERROR_CODE_LOOKUP_FAILED" | "ERROR_CODE_SHIFT_ALREADY_EXISTS" | "ERROR_CODE_CREATION_NOT_ALLOWED" | "ERROR_CODE_CREATE_ISSUE" | "ERROR_CODE_DUPLICATE_PHONE_NUMBER" | "ERROR_CODE_DUPLICATE_EMAIL" | "ERROR_CODE_ALREADY_EXISTS" | "ERROR_CODE_CREATION_FAILED" | "ERROR_CODE_UPDATE_NOT_ALLOWED" | "ERROR_CODE_UPDATE_FAILED" | "ERROR_CODE_UPDATE_INVALID" | "ERROR_CODE_DELETION_NOT_ALLOWED" | "ERROR_CODE_DELETION_FAILED" | "ERROR_CODE_DELETION_INVALID" | "ERROR_CODE_GORM_TO_PROTO_CONVERSION" | "ERROR_CODE_PROTO_TO_GORM_CONVERSION" | "ERROR_CODE_DATA_MARSHALING_FAILED" | "ERROR_CODE_INTERNAL" | "ERROR_CODE_PERMIFY_ISSUE" | "ERROR_CODE_STORAGE_SERVICE_ISSUE" | "ERROR_CODE_WHATSAPP_SENDING_ISSUE" | "ERROR_CODE_EMAIL_SENDING_ISSUE" | "ERROR_CODE_DATABASE_ISSUE" | "ERROR_CODE_NOSQL_DATABASE_ISSUE" | "ERROR_CODE_VRP_SERVICE_ISSUE" | "ERROR_CODE_COST_PROVIDER_ISSUE" | "ERROR_CODE_VOXIMPLANT_ISSUE" | "ERROR_CODE_ENCRYPTION_FAILED" | "ERROR_CODE_DECRYPTION_FAILED" | "ERROR_CODE_ROUTE_FINAL" | "ERROR_CODE_ROUTE_NOT_RETURNING" | "ERROR_CODE_ROUTE_INVALID_TRANSITION" | "ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT" | "ERROR_CODE_ROUTE_NOT_APPROVABLE" | "ERROR_CODE_ROUTE_NOT_APPROVED" | "ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED" | "ERROR_CODE_ROUTE_NO_DESTINATION" | "ERROR_CODE_ROUTE_NOT_DISSOLVABLE" | "ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION" | "ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS" | "ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE" | "ERROR_CODE_ROUTE_DURATION_TOO_SHORT" | "ERROR_CODE_ROUTE_STOP_AMBIGUOUS" | "ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB" | "ERROR_CODE_ROUTE_RETURNING" | "ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE" | "ERROR_CODE_JOB_NOT_IN_ROUTE" | "ERROR_CODE_JOB_ALREADY_ON_SERVICE" | "ERROR_CODE_JOB_NOT_ON_SERVICE" | "ERROR_CODE_JOB_FINAL" | "ERROR_CODE_JOB_NOT_DETACHABLE" | "ERROR_CODE_JOB_INVALID_TRANSITION" | "ERROR_CODE_JOB_NOT_ENROUTE" | "ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT" | "ERROR_CODE_JOB_NOT_COMPLETED" | "ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE" | "ERROR_CODE_JOB_LIST_CONFLICT" | "ERROR_CODE_JOB_NOT_LISTED" | "ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY" | "ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH" | "ERROR_CODE_JOB_HAS_NO_ROUTE" | "ERROR_CODE_JOB_ALREADY_ASSIGNED" | "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE" | "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE" | "ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE" | "ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER" | "ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY" | "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY" | "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT" | "ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION" | "ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED" | "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE" | "ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK" | "ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE" | "ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT" | "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE" | "ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED" | "ERROR_CODE_TRUCK_JOB_LIMIT" | "ERROR_CODE_TRUCK_JOB_INCOMPATIBLE" | "ERROR_CODE_TRUCK_NO_DEPOT" | "ERROR_CODE_TRUCK_NO_TYPE" | "ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET" | "ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET" | "ERROR_CODE_TRUCK_NOT_ACTIVE" | "ERROR_CODE_CONTAINER_GROUP_NOT_BOUND" | "ERROR_CODE_CONTRACT_PARTIES_MISMATCH" | "ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE" | "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY" | "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE" | "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING" | "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP" | "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES" | "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD" | "ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE" | "ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE" | "ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT" | "ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED" | "ERROR_CODE_PICKUP_LOCATION_TOO_FAR" | "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK" | "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS" | "ERROR_CODE_ORGANIZATION_MISMATCH" | "ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER" | "ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER" | "ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS" | "ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE" | "ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER" | "ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT" | "ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS" | "ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH" | "ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION" | "ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE" | "ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER" | "ERROR_CODE_CONTACT_NO_PHONE_NUMBER" | "ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED" | "ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY" | "ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED" | "ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE" | "ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE" | "ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED" | "ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN" | "ERROR_CODE_TYPE_OUTSIDE_HOLDING" | "ERROR_CODE_TYPE_NOT_OWNED" | "ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING" | "ERROR_CODE_TRUCK_TYPE_IN_USE" | "ERROR_CODE_COMPANY_NOT_SELECTED";

/**
 * Describes the enum raccoonai.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode, ErrorCodeJson> = /*@__PURE__*/
  enumDesc(file_general, 0);

/**
 * @generated from enum raccoonai.ResponseStatus
 */
export enum ResponseStatus {
  /**
   * @generated from enum value: RESPONSE_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: RESPONSE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RESPONSE_STATUS_NOT_FOUND = 2;
   */
  NOT_FOUND = 2,

  /**
   * @generated from enum value: RESPONSE_STATUS_SERVER_ERROR = 3;
   */
  SERVER_ERROR = 3,
}

/**
 * @generated from enum raccoonai.ResponseStatus
 */
export type ResponseStatusJson = "RESPONSE_STATUS_UNDEFINED" | "RESPONSE_STATUS_OK" | "RESPONSE_STATUS_NOT_FOUND" | "RESPONSE_STATUS_SERVER_ERROR";

/**
 * Describes the enum raccoonai.ResponseStatus.
 */
export const ResponseStatusSchema: GenEnum<ResponseStatus, ResponseStatusJson> = /*@__PURE__*/
  enumDesc(file_general, 1);

/**
 * @generated from enum raccoonai.SortDirection
 */
export enum SortDirection {
  /**
   * @generated from enum value: SORT_DIRECTION_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: SORT_DIRECTION_ASCENDING = 1;
   */
  ASCENDING = 1,

  /**
   * @generated from enum value: SORT_DIRECTION_DESCENDING = 2;
   */
  DESCENDING = 2,
}

/**
 * @generated from enum raccoonai.SortDirection
 */
export type SortDirectionJson = "SORT_DIRECTION_UNDEFINED" | "SORT_DIRECTION_ASCENDING" | "SORT_DIRECTION_DESCENDING";

/**
 * Describes the enum raccoonai.SortDirection.
 */
export const SortDirectionSchema: GenEnum<SortDirection, SortDirectionJson> = /*@__PURE__*/
  enumDesc(file_general, 2);

